/* THE STUDIO — title burn-in, the photo lightbox, and the rolling end credits. */
(function () {
  var root = document.querySelector('[data-nhp-studio]');
  if (!root) return;
  var html = document.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1 · burn the title in once the Leader has gone (it plays over every page load) */
  var burn = root.querySelector('[data-nhp-st-burn]');
  if (burn && !reduce) {
    burn.classList.add('is-ready');
    var go = function () { burn.classList.add('is-on'); };
    if (!html.classList.contains('nhp-ident-on')) go();
    else new MutationObserver(function (m, obs) {
      if (!html.classList.contains('nhp-ident-on')) { obs.disconnect(); go(); }
    }).observe(html, { attributes: true, attributeFilter: ['class'] });
  }

  /* 2 · lightbox. Cleanup lives in closeLb(), NOT a 'close' listener — dialog.close() fires no close
     event on this storefront (README trap). */
  var lb = root.querySelector('[data-nhp-st-lb]');
  var lbImg = root.querySelector('[data-nhp-st-lb-img]');
  var lbCap = root.querySelector('[data-nhp-st-lb-cap]');
  var opener = null;
  function closeLb() {
    if (lb.open) lb.close();
    lbImg.removeAttribute('src');
    if (opener) opener.focus();
    opener = null;
  }
  if (lb && lb.showModal) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nhp-st-open]');
      if (!btn) return;
      opener = btn;
      lbImg.src = btn.getAttribute('data-nhp-st-open');
      lbImg.alt = btn.getAttribute('data-cap') || '';
      lbCap.textContent = btn.getAttribute('data-cap') || '';
      lb.showModal();
    });
    root.querySelector('[data-nhp-st-close]').addEventListener('click', closeLb);
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.open) { e.preventDefault(); closeLb(); } });
  }

  /* 3 · the end credits roll up once, when the section is on screen, and stop with the studio card
     centred in the window. Under reduced motion they stay a plain list. */
  var roll = root.querySelector('[data-nhp-roll]');
  if (!roll || reduce || !('IntersectionObserver' in window)) return;
  var track = roll.querySelector('[data-nhp-roll-track]');
  var end = roll.querySelector('[data-nhp-roll-end]');
  var pause = root.querySelector('[data-nhp-roll-pause]');
  var SPEED = 42; // px a second — slow enough to read every line

  roll.classList.add('is-ready');
  function measure() {
    var win = roll.clientHeight;
    var endMid = end.offsetTop + end.offsetHeight / 2;
    var from = win;                    // start just below the window
    var to = win / 2 - endMid;         // finish with the studio card centred
    roll.style.setProperty('--roll-from', from + 'px');
    roll.style.setProperty('--roll-to', to + 'px');
    roll.style.setProperty('--roll-dur', ((from - to) / SPEED).toFixed(1) + 's');
  }
  measure();

  var started = false;
  new IntersectionObserver(function (entries, obs) {
    if (!entries[0].isIntersecting || started) return;
    started = true;
    obs.disconnect();
    measure();
    roll.classList.add('is-rolling');
    pause.hidden = false;
  }, { threshold: 0.35 }).observe(roll);

  pause.addEventListener('click', function () {
    var paused = roll.classList.toggle('is-paused');
    pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
    pause.querySelector('.nhp-sr').textContent = paused ? 'Play the credits' : 'Pause the credits';
  });
  track.addEventListener('animationend', function () { pause.hidden = true; });
})();

/* 1b + 2b (2026-09-23): the director's Polaroid develops, and each clapperboard snaps shut, once, when reached */
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  var els = [].slice.call(document.querySelectorAll('[data-nhp-develop], [data-nhp-slate]'));
  if (!els.length) return;
  els.forEach(function (el) { el.classList.add('is-ready'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.55 });
  els.forEach(function (el) { io.observe(el); });
})();
